// 创建优惠码页面
<template>
  <div>
    <p style="text-align: center;">
      <span class="systemFont0">{{ $t("newYouHuiMa.createCouponCode") }}</span>
    </p>


<el-row>
      <p style="text-align: center;">
      <el-button
        style="float:right;margin-right:14%"
        type="text"
        @click.native="getQrcodeImg()"
        >{{ $t("newYouHuiMa.createQrCode") }}</el-button
      >
    </p>
    <div class="main">
      <el-form
        class="systemFont1"
        :model="couponCode"
        label-width="150px"
        style="width:90%;"
        hide-required-asterisk
      >
        <el-row>
          <el-col :span="11" :offset="2">
            <!-- 证书 -->
            <el-form-item
              :label="$t('newYouHuiMa.certificate')"
              prop="certificate"
            >
              <el-select
                v-model="couponCode.certificateName"
                size="small"
                style="width: 100%"
                :placeholder="$t('common.pleaseSelect')"
              >
                <el-option
                  v-for="item in certificateList"
                  :key="item.certificateName"
                  :label="item.certificateName"
                  :value="item.certificateName"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- 绿夹克上课名称 -->
            <el-form-item :label="$t('newYouHuiMa.greenJacketClassName')">
              <el-select
                v-model="couponCode.courseNumber"
                size="small"
                style="width: 100%"
                @change="getScheduleByCourse(couponCode.courseNumber)"
                :placeholder="$t('common.pleaseSelect')"
              >
                <el-option
                  v-for="item in courseNameList"
                  :key="item.courseNumber"
                  :label="item.courseName"
                  :value="item.courseNumber"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <!-- TQS模块使用 -->
            <el-form-item :label="$t('newYouHuiMa.TQSTemplateUsage')">
              <el-select
                v-model="couponCode.tqsModuleKey"
                size="small"
                style="width: 100%"
                :placeholder="$t('common.pleaseSelect')"
              >
                <el-option
                  v-for="item in tqsModuleList"
                  :key="item.tqsModuleKey"
                  :label="item.tqsModuleName"
                  :value="item.tqsModuleKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- 绿夹克上课日期 -->
            <el-form-item :label="$t('newYouHuiMa.greenJacketClassDate')">
              <el-select
                v-model="couponCode.courseDate"
                size="small"
                style="width: 100%"
                :placeholder="$t('common.pleaseSelect')"
              >
                <el-option
                  v-for="item in classDateList"
                  :key="item.courseDate"
                  :label="item.courseDate"
                  :value="item.courseDate"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22" :offset="2">
            <!-- 个人用户入力 -->
            <el-form-item :label="$t('newYouHuiMa.individualUser')">
              <el-input
                v-model="couponCode.userSearchValue"
                size="small"
                maxlength="125"
                :placeholder="$t('newYouHuiMa.queryCriteria')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="text-align: center">
      <el-button type="submit" @click="getUserInfo()">{{
        $t("common.query")
      }}</el-button>
      <el-button type="submit" class="buttonWidth" @click="reset">{{
        $t("common.reset")
      }}</el-button>
    </div>
    <!-- 用户列表 -->
    <div v-if="showFlag" style="margin-top: 50px;">
      <el-col :span="22" :offset="1">
      <el-table
        ref="userList"
        :data="userList"
        tooltip-effect="dark"
        style="min-width: 1200px;"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          align="center"
          width="55"
        ></el-table-column>
        <!-- 优惠码级别 -->
        <el-table-column
          :label="$t('newYouHuiMa.promoCodeLevel')"
          align="center"
          min-width="65"
        >
          <!-- 优惠码下拉框 -->
          <template slot-scope="scope">
            <el-select
              autosize
              size="mini"
              v-model="scope.row.couponCodeLevel"
              controls-position="right"
            >
              <el-option
                v-for="item in couponCodeList"
                :key="item.levelKey"
                :label="item.levelValue"
                :value="item.levelKey"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <!-- 头像 -->
        <el-table-column
          min-width="40"
          :label="$t('newYouHuiMa.avatar')"
          align="center"
        >
          <template slot-scope="scope">
            <el-avatar
              :src="viewHeadPortrait(scope.row.headPortrait)"
              :key="scope.row.headPortrait"
              :size="30"
            ></el-avatar>
          </template>
        </el-table-column>
        <!-- 姓名-->
        <el-table-column
          min-width="60"
          :label="$t('newYouHuiMa.name')"
          align="center"
        >
          <!-- 姓名 -->
          <template slot-scope="scope">
            {{ scope.row.lastName +" "+ scope.row.firstName }}
          </template></el-table-column
        >
        <!-- 英文姓名 -->
        <el-table-column
          :label="$t('newYouHuiMa.englishName')"
          min-width="75"
          align="center"
        >
          <!-- 英文姓名 -->
          <template slot-scope="scope">
            {{
              scope.row.lastNameEn === null
                ? ""
                : scope.row.lastNameEn +" "+ scope.row.firstNameEn
            }}
          </template></el-table-column
        >
        <!-- 邮箱 -->
        <el-table-column
          :label="$t('newYouHuiMa.email')"
          min-width="110"
          align="center"
        >
          <!-- 邮箱 -->
          <template slot-scope="scope">
            {{
              scope.row.email === null
                ? scope.row.supplyEmail
                : scope.row.email
            }}
          </template>
        </el-table-column>
        <!-- 手机号码 -->
        <el-table-column
          :label="$t('newYouHuiMa.phoneNumber')"
          min-width="100"
          align="center"
        >
          <!-- 手机号码 -->
          <template slot-scope="scope">
            {{
              scope.row.phoneNo === null
                ? scope.row.supplyPhoneNumber
                : scope.row.phoneArea + " " + scope.row.phoneNo
            }}
          </template>
        </el-table-column>
        <!-- 关联公司 -->
        <el-table-column
          prop="affiliation"
          :label="$t('newYouHuiMa.affiliation')"
          align="left"
          min-width="150"
        ></el-table-column>
        <!-- 注册日期 -->
        <el-table-column
          prop="createTime"
          min-width="70"
          :label="$t('newYouHuiMa.registerDate')"
          align="center"
        ></el-table-column>
        <!-- 上次登录 -->
        <el-table-column
          prop="loginTime"
          min-width="70"
          :label="$t('newYouHuiMa.lastLogin')"
          align="center"
        ></el-table-column>
        <!-- 操作 -->
        <el-table-column
          :label="$t('common.operation')"
          min-width="70"
          align="center"
        >
          <template slot-scope="scope">
            <el-button size="text" @click="createAndNotify(scope.row)">{{
              $t("newYouHuiMa.createAndNotify")
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-row class="foot-container" style="margin-bottom: 50px;">
        <el-col :span="12">
          <!--创建并通知  -->
          <el-button
            :disabled="createFlag"
            type="p0332Button"
            @click="createAndNotifyAll()"
            >{{ $t("newYouHuiMa.createAndNotify") }}</el-button
          >
        </el-col>
        <el-col :span="12">
          <!-- 返回 -->
          <el-button type="return" @click="$router.go(-1)">{{
            $t("common.back")
          }}</el-button>
        </el-col>
      </el-row>
      </el-col>
    </div>
    </el-row>
    <!-- 错误信息列表  -->
    <el-dialog
      class="dialogError"
      :visible.sync="listVisible"
      :title="$t('p0332.errorMessage')"
      width="560px"
      center
    >
      <el-table :data="errMsgList" style="margin-bottom: 75px">
        <el-table-column :show-header="false" align="center">
          <template slot-scope="scope">
            <span class="errdialog">{{ scope.row.errorMessage }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!--    二维码显示-->

    <el-dialog
      :title="$t('newYouHuiMa.qrCodeTitle')"
      :visible.sync="qrCodeVisiable"
      width="450px"
      :before-close="
        () => {
          this.qrCodeVisiable = false;
        }
      "
    >
      <span>
        <el-image :src="qrCodeImg"> </el-image>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
export default {
  data() {
    return {
      //默认头像
      defaultImg: require("../../../assets/headPortrait.png"),
      levelValue: 0,
      // 表格显示状态
      showFlag: false,
      userList: [],
      // 优惠码
      couponCode: {
        courseDate: ""
      },
      // 错误信息列表
      errMsgList: [],
      // 错误信息列表弹框控制
      listVisible: false,
      // 创建通知标志
      createFlag: false,
      // 证书列表
      certificateList: [],
      // TQS模板使用列表
      tqsModuleList: [],
      // 绿夹克上课名称列表
      courseNameList: [],
      // 绿夹克上课日期
      classDateList: [],
      // 优惠码列表
      couponCodeList: [],
      // 选择的用户
      multipleSelection: [],
      // 二维码dialog
      qrCodeVisiable: false,
      //  二维码图片数据
      qrCodeImg: ""
    };
  },
  watch: {
    // 监听勾选的用户
    "multipleSelection.length": function(val){
      if(val == 0){
        this.createFlag = true;
      } else {
        this.createFlag = false;
      }
    }
  },
  methods: {
    //选择的用户
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 头像图片显示
    viewHeadPortrait(imgCodeStr) {
      return imgCodeStr == null
        ? this.defaultImg
        : "data:image/png;base64," + imgCodeStr;
    },
    // 重置表单
    reset() {
      this.couponCode = {
        courseDate: ""
      };
      this.classDateList = [];
      this.userList = [];
      this.createFlag = true;
    },
    // 查询用户信息
    getUserInfo() {
      this.errMsgList = [];
      this.query();
    },
    // 查询用户信息
    query() {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        spinner: "el-icon-loading",
        background: "hsla(0, 0%, 100%, 0.9)",
        target: document.querySelector("#main-container")
      });
      this.showFlag = true;
      let url = "/api/couponCode/searchUserInfo";
      this.$http
        .post(url, qs.stringify(this.couponCode))
        .then(response => {
          if (response.data.code === 200) {
            // this.errMsgList = [];
            this.userList = response.data.data;
            this.$nextTick(() => {
              this.$refs.userList.clearSelection();
              this.$refs.userList.toggleAllSelection();
            });
            // 设置创建与通知按钮禁用状态
            if (this.userList.length == 0) {
              this.createFlag = true;
            } else {
              this.createFlag = false;
            }
            console.log(response.data.data);
            loading.close();
          } else {
            loading.close();
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 初始化取值
    createCouponCodeInit() {
      let url = "/api/couponCode/createCouponCodeInit";
      this.$http
        .get(url)
        .then(response => {
          if (response.data.code === 200) {
            console.log(response.data.data);
            this.tqsModuleList = response.data.data.tqsModuleList;
            this.certificateList = response.data.data.certificateList;
            this.courseNameList = response.data.data.courseNameList;
            this.couponCodeList = response.data.data.couponCodeLevelList;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 根据课程查询排课时间
    getScheduleByCourse(courseNumber) {
      this.couponCode.courseDate = "";
      console.log(courseNumber);
      let url = "/api/couponCode/getScheduleByCourse";
      this.$http
        .post(url, qs.stringify({ courseNumber: courseNumber }))
        .then(response => {
          if (response.data.code === 200) {
            console.log(response.data.data);
            this.classDateList = response.data.data;
            // let classDate = this.classDateList[0].courseDate
            // console.log("🚀 ~ file: P0411.vue:362 ~ getScheduleByCourse ~ this.classDateList[0]", this.classDateList[0])
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 创建并发送通知
    createAndNotify(row) {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        spinner: "el-icon-loading",
        background: "hsla(0, 0%, 100%, 0.9)",
        target: document.querySelector("#main-container")
      });
      // console.log(row);
      let url = "/api/couponCode/createCouponCodeAndNotice";
      this.$http
        .post(url, [row])
        .then(response => {
          if (response.data.code === 200) {
            loading.close();
            console.log(response.data);
            if (response.data.message === "error") {
              // // 错误信息列表
              this.errMsgList = response.data.data;
              this.query();
              this.listVisible = true;
            } else {
              this.$message.success(response.data.data);
              this.query();
            }
          } else {
            loading.close();
            this.$message.error(this.$t("common.anErrorOccurred"));
          }
        })
        .catch(err => {
          loading.close();
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 批量创建并通知
    createAndNotifyAll() {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        spinner: "el-icon-loading",
        background: "hsla(0, 0%, 100%, 0.9)",
        target: document.querySelector("#main-container")
      });
      // console.log(this.multipleSelection);
      let url = "/api/couponCode/createCouponCodeAndNotice";
      this.$http
        .post(url, this.multipleSelection)
        .then(response => {
          if (response.data.code === 200) {
            loading.close();
            // console.log(response.data);
            if (response.data.message === "error") {
              // // 错误信息列表
              this.errMsgList = response.data.data;
              this.query();
              // this.tableRowClassName(this.errMsgList)
              this.listVisible = true;
            } else {
              this.$message.success(response.data.data);
              this.query();
            }
          } else {
            loading.close();
            this.$message.error(this.$t("common.anErrorOccurred"));
          }
        })
        .catch(err => {
          loading.close();
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },

    //标红table指定行
    tableRowClassName({ row, rowIndex }) {
      //判断条件（quantityStock ，warningLimit ，quantityStock 列表字段信息）
      const uIdList = this.errMsgList.map(errMsg => {
        return errMsg.userId;
      });
      if (uIdList) {
        if (uIdList.indexOf(row.userId) > -1) {
          return "warning-row";
        }
      }
      return "";
    },

    // 获取二维码
    getQrcodeImg() {
      let url = "/api/individualQuery/getQrcode";
      this.$http
        .get(url)
        .then(resp => {
          if (resp.data.code === 200) {
            console.log(resp.data);
            this.qrCodeImg = resp.data.data;
            this.qrCodeVisiable = true;
          } else {
            this.$message.error(this.$t("common.anErrorOccurred"));
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    }
  },
  mounted() {
    this.createCouponCodeInit();
  }
};
</script>

<style lang="scss" scoped>
>>> .el-table .warning-row {
  color: #f51f1f !important;
}
.main {
  // min-width:1310px;
  width: 90%;
  margin: 0 auto;
  padding-top: 17px;
  display: flex;
}
>>> .el-table__row {
  height: 42px;
}
>>> .el-table .cell {
  line-height: 28px;
}
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 14px;
}
>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  line-height: 18px;
  border-bottom: 0.5px solid rgb(170, 170, 170);
}
>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}
>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}
.foot-container {
  margin-top: 5%;
  margin-left: 40%;
  width: 20%;
  text-align: center;
}
>>> .el-button--return {
  width: 97px;
}
>>> .buttonWidth {
  width: 61px;
  background-color: rgb(255, 255, 255);
  color: rgb(0, 176, 240);
}
>>> .el-table .el-table__cell {
  padding: 8.5px 0;
}
>>> .dialogError .el-dialog__body {
  padding: 3px 30px;
  overflow-y: auto;
  height: calc(80vh - 140px);
}
>>> .dialogError .el-table__header {
  border-bottom: 1px solid rgb(170, 170, 170);
}
>>> .dialogError .el-table th.el-table__cell.is-leaf {
  border-bottom: 0px solid rgb(170, 170, 170);
}
</style>



// WEBPACK FOOTER //
// src/views/Marketing/CouponCode/P0411.vue